import { render, staticRenderFns } from "./sph-modal.vue?vue&type=template&id=2c68dd53&"
import script from "./sph-modal.vue?vue&type=script&lang=js&"
export * from "./sph-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports